import { Link } from 'react-router-dom';
import styled from 'styled-components';

import SvgIcon from '~src/shared/SvgIcon';
import SecondaryButton from '~src/shared/buttons/basicButtons/SecondaryButton.sc';
import { media } from '~src/styles/media-templates';

export const OverlayContainer = styled.section`
  height: 100%;
  width: 100%;
  background-color: ${({ theme }) => theme.mobileBlue.a10};
  ${media.phone`
    background-image: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 30px;
  `}
`;

export const MessageText = styled.span`
  margin-top: 15px;
  width: 100%;
  padding: 15px;
`;

export const MessageContainer = styled.div<{ $grow: number; $noBorder?: boolean }>`
  width: 100%;
  flex-grow: ${({ $grow }) => $grow || 'unset'};
  border-top: ${({ $noBorder }) => ($noBorder ? 'none' : '1px rgba(255, 255, 255, 0.3) solid')};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-size: 15px;
  line-height: 26px;
  justify-content: center;
  color: ${({ theme }) => theme.white.a10};
`;

export const RefreshIcon = styled(SvgIcon)`
  &.white {
    color: ${({ theme }) => theme.white.a10};
  }
`;

export const StyledLink = styled(Link)`
  width: 100%;
`;

export const MobileButton = styled(SecondaryButton)`
  border: 1px solid ${({ theme }) => theme.white.a10};
  color: ${({ theme }) => theme.white.a10};
  width: 100%;
  margin-top: 15px;
`;
